module.exports = __webpack_public_path__ + "static/media/10.87399b12.png";